document.addEventListener("DOMContentLoaded", function () {
    function getFlooringCalculatorRoot() {
      return document.querySelector('[data-block-handle="calculator"] .calculator-div');
    }

    function getFlooringQuantityInput() {
      const root = getFlooringCalculatorRoot();
      if (!root) return null;
      const sectionId = root.getAttribute("data-section-id");
      if (sectionId) {
        const byId = root.querySelector("#Quantity-" + sectionId);
        if (byId) return byId;
      }
      return root.querySelector('quantity-selector-component input[name="quantity"]');
    }

    const calculatorRoot = getFlooringCalculatorRoot();
    if (!calculatorRoot) return;

    const totalAreaRadio = calculatorRoot.querySelector("#total-area");
    const widthLengthRadio = calculatorRoot.querySelector("#Width-Length");
  
    const areaInputContainer = calculatorRoot.querySelector(".input-container-area");
    const lengthWidthInputsContainer = calculatorRoot.querySelector(".length-width-inputs");

    if (!totalAreaRadio || !widthLengthRadio || !areaInputContainer || !lengthWidthInputsContainer) return;
  
    function toggleInputFields() {
      if (totalAreaRadio.checked) {
        areaInputContainer.classList.remove("hidden");
        lengthWidthInputsContainer.classList.add("hidden");
        lengthWidthInputsContainer.classList.remove("flex", "flex-col", "gap-3", "mt-2");
      } else {
        areaInputContainer.classList.add("hidden");
        lengthWidthInputsContainer.classList.remove("hidden");
        lengthWidthInputsContainer.classList.add("flex", "flex-col", "gap-3", "mt-2");
      }
    }
  
    toggleInputFields();
  
    totalAreaRadio.addEventListener("change", toggleInputFields);
    widthLengthRadio.addEventListener("change", toggleInputFields);
  
    let currentUnit = "meters";
  
    function convertToMeters(value, unit, isArea = false) {
      if (isNaN(value)) return 0;
      if (unit === "feet") {
        return isArea ? value / 10.764 : value / 3.281;
      }
      if (unit === "cm") {
        return isArea ? value / 10000 : value / 100;
      }
      return value;
    }
  
    function updateLabels() {
      const unitLabels = {
        meters: { width: "m", length: "m", area: "m²" },
        cm: { width: "cm", length: "cm", area: "cm²" },
        feet: { width: "ft", length: "ft", area: "ft²" },
      };
      const labels = unitLabels[currentUnit] || unitLabels.meters;
      const lw = calculatorRoot.querySelector("label[for='calculator-width']");
      const ll = calculatorRoot.querySelector("label[for='calculator-length']");
      const la = calculatorRoot.querySelector("label[for='calculator-area']");
      if (lw) lw.innerHTML = labels.width;
      if (ll) ll.innerHTML = labels.length;
      if (la) la.innerHTML = labels.area;
    }
  
    function updatePriceDisplay(totalPrice) {
      if (typeof totalPrice !== "number" || isNaN(totalPrice)) return;
      const priceDisplay = document.getElementById("total-price-display");
      if (priceDisplay) {
        priceDisplay.innerHTML = `£${totalPrice.toFixed(2)}`;
      }
    }
  
    // Function to update price based on quantity selector
    function updatePriceFromQuantitySelector() {
      try {
        const quantityPicker = getFlooringQuantityInput();
        
        if (quantityPicker) {
          const quantity = parseInt(quantityPicker.value, 10) || 0;
          const perPackPrice = parseFloat(calculatorRoot.getAttribute('data-per-pack-price')) || 0;
          const totalPrice = quantity * perPackPrice;
  
          // Update the Total Packs and m² display fields
          const qtyRequired = document.getElementById("qty-required");
          const areaRequiredValue = document.getElementById("area-required-value");
          const coverage = parseFloat(calculatorRoot.getAttribute("data-metafield-coverage")) || 1;
  
          if (qtyRequired) {
            qtyRequired.innerHTML = `Total Packs: ${quantity}`;
          }
          if (areaRequiredValue) {
            const totalArea = (quantity * coverage).toFixed(2);
            areaRequiredValue.innerHTML = totalArea;
          }
  
          updatePriceDisplay(totalPrice);
        }
      } catch (error) {
        console.warn('Error updating price from quantity selector:', error);
      }
    }
  
    function resetCalculatorResults() {
      const qtyRequired = document.getElementById("qty-required");
      const areaRequiredValue = document.getElementById("area-required-value");
      if (qtyRequired) qtyRequired.innerHTML = "Total Packs: 0";
      if (areaRequiredValue) areaRequiredValue.innerHTML = "0";
      updatePriceDisplay(0);
    }

    // Function to update quantity selector from calculator
    function updateQuantitySelector(quantity) {
      const quantityPicker = getFlooringQuantityInput();
      if (!quantityPicker) return;

      const min = parseInt(quantityPicker.getAttribute("min"), 10) || 1;
      const n = parseInt(quantity, 10);
      const value = !Number.isFinite(n) || n < min ? min : n;

      quantityPicker.value = String(value);
      quantityPicker.setAttribute("value", String(value));
      quantityPicker.dispatchEvent(new Event("change", { bubbles: true }));
    }
  
    function calculateQuantityLengthWidth() {
      const width = parseFloat(document.getElementById("calculator-width").value);
      const length = parseFloat(document.getElementById("calculator-length").value);
      const addWastage = document.getElementById("add-wastage").checked;
  
      if (isNaN(width) || isNaN(length)) {
        resetCalculatorResults();
        return;
      }
  
      const coverage = parseFloat(calculatorRoot.getAttribute("data-metafield-coverage"));
      let convertedWidth = convertToMeters(width, currentUnit);
      let convertedLength = convertToMeters(length, currentUnit);
      let output = convertedWidth * convertedLength;
      if (addWastage) output *= 1.10;
  
      let areaOutput = output.toFixed(2);
      output = Math.ceil(output / coverage);
  
      document.getElementById("qty-required").innerHTML = "Total Packs: " + output;
      document.getElementById("area-required-value").innerHTML = areaOutput;
  
      updateQuantitySelector(output);
  
      const perPackPrice = parseFloat(calculatorRoot.getAttribute('data-per-pack-price')) || 0;
      const totalPrice = output * perPackPrice;
  
      updatePriceDisplay(totalPrice);
    }
  
    function calculateQuantityArea() {
      const area = parseFloat(document.getElementById("calculator-area").value);
      const addWastage = document.getElementById("add-wastage").checked;
  
      if (isNaN(area)) {
        resetCalculatorResults();
        return;
      }
  
      const coverage = parseFloat(calculatorRoot.getAttribute("data-metafield-coverage"));
      let output = convertToMeters(area, currentUnit, true);
      if (addWastage) output *= 1.10;
  
      let areaOutput = output.toFixed(2);
      output = Math.ceil(output / coverage);
  
      document.getElementById("qty-required").innerHTML = "Total Packs: " + output;
      document.getElementById("area-required-value").innerHTML = areaOutput;
  
      updateQuantitySelector(output);
  
      const perPackPrice = parseFloat(calculatorRoot.getAttribute('data-per-pack-price')) || 0;
      const totalPrice = output * perPackPrice;
  
      updatePriceDisplay(totalPrice);
    }
  
    function wastage() {
      const width = parseFloat(document.getElementById("calculator-width").value);
      const length = parseFloat(document.getElementById("calculator-length").value);
      const area = parseFloat(document.getElementById("calculator-area").value);
  
      if (!isNaN(width) || !isNaN(length)) {
        document.getElementById("calculator-area").value = "";
        calculateQuantityLengthWidth();
      } else if (!isNaN(area)) {
        document.getElementById("calculator-width").value = "";
        document.getElementById("calculator-length").value = "";
        calculateQuantityArea();
      } else {
        resetCalculatorResults();
      }
    }
  
    function wastageLengthWidth() {
      const width = parseFloat(document.getElementById("calculator-width").value);
      const length = parseFloat(document.getElementById("calculator-length").value);
      if (!isNaN(width) || !isNaN(length)) {
        document.getElementById("calculator-area").value = "";
        calculateQuantityLengthWidth();
      } else {
        resetCalculatorResults();
      }
    }
  
    function wastageArea() {
      const areaInput = document.getElementById("calculator-area");
      if (!areaInput) return;

      const area = parseFloat(areaInput.value);
      if (!isNaN(area)) {
        const widthInput = document.getElementById("calculator-width");
        const lengthInput = document.getElementById("calculator-length");
        if (widthInput) widthInput.value = "";
        if (lengthInput) lengthInput.value = "";
      }
      calculateQuantityArea();
    }
  
    const unitRadios = calculatorRoot.querySelectorAll('input[name="measurement-unit"]');
  
    function updateUnit() {
      const selectedUnit = calculatorRoot.querySelector("input[name='measurement-unit']:checked");
      if (selectedUnit) {
        currentUnit = selectedUnit.value;
        updateLabels();
        wastage();
      }
    }
  
    unitRadios.forEach((radio) => {
      radio.addEventListener("change", updateUnit);
    });
  
    updateUnit();
  
    calculatorRoot.querySelector("#calculator-width")?.addEventListener("input", wastageLengthWidth);
    calculatorRoot.querySelector("#calculator-length")?.addEventListener("input", wastageLengthWidth);
    calculatorRoot.querySelector("#calculator-area")?.addEventListener("input", wastageArea);
    calculatorRoot.querySelector("#add-wastage")?.addEventListener("change", wastage);
  
    // Add event listeners for quantity selector
    function setupQuantitySelectorListeners() {
      const quantityPicker = getFlooringQuantityInput();
      if (!quantityPicker || quantityPicker.dataset.flooringQtyBound === "1") return;
      quantityPicker.dataset.flooringQtyBound = "1";

      quantityPicker.addEventListener("input", updatePriceFromQuantitySelector);
      quantityPicker.addEventListener("change", updatePriceFromQuantitySelector);
    }
  
    // Setup quantity selector listeners on load
    setupQuantitySelectorListeners();
  
    // Optimized MutationObserver with error handling
    let observer = null;
    try {
      observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
            // Debounce the setup to prevent excessive calls
            clearTimeout(window.quantitySetupTimeout);
            window.quantitySetupTimeout = setTimeout(setupQuantitySelectorListeners, 100);
          }
        });
      });
  
      // Observe the calculator div for changes
      if (calculatorRoot) {
        observer.observe(calculatorRoot, { childList: true, subtree: true });
      }
    } catch (error) {
      console.warn('MutationObserver setup failed:', error);
    }
  
    function clearCalculationInputs() {
      const areaInput = document.getElementById("calculator-area");
      const widthInput = document.getElementById("calculator-width");
      const lengthInput = document.getElementById("calculator-length");
      const wastageCheckbox = document.getElementById("add-wastage");

      if (areaInput) areaInput.value = "";
      if (widthInput) widthInput.value = "";
      if (lengthInput) lengthInput.value = "";
      if (wastageCheckbox) wastageCheckbox.checked = false;
    }

    function resetPriceDisplay() {
      const isPacksTabActive = document
        .getElementById("packs-header-button")
        ?.classList.contains("active");

      clearCalculationInputs();

      if (isPacksTabActive) {
        getFlooringQuantityInput()?.dispatchEvent(
          new Event("change", { bubbles: true })
        );
        return;
      }

      resetCalculatorResults();

      const quantityPicker = getFlooringQuantityInput();
      if (quantityPicker) {
        const min = parseInt(quantityPicker.getAttribute("min"), 10) || 1;
        quantityPicker.value = String(min);
        quantityPicker.setAttribute("value", String(min));
      }
    }

    if (window.ThemeBus) {
      window.ThemeBus.addEventListener("cart:updated", resetPriceDisplay);
    }

    function cleanup() {
      if (observer) {
        observer.disconnect();
      }
      clearTimeout(window.quantitySetupTimeout);
    }
  
    // Cleanup on page unload
    window.addEventListener('beforeunload', cleanup);
  
    updateLabels();
  });